export enum HTTP_METHOD {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}

export enum ROLE_NAME {
  ADMIN = 'Administrator',
  USER = 'User',
}

export type Role = 'admin' | 'manager' | 'receptionist' | 'develop';

export const RoleType = ['owner', 'coOwner', 'system'];

export const allowImgExt = ['jpeg', 'png', 'bmp', 'tiff', 'jpg'];

export enum USER_ROLE {
  ADMIN = 'admin',
  MANAGER = 'manager',
  RECEPTIONIST = 'receptionist',
  DEVELOP = 'develop',
}
export enum SCREEN_TYPE_DRIVER_MANAGEMENT {
  list = 'list',
  register = 'register',
  detail = 'detail',
}

export enum DASHBOARD_TAB {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export enum SCREEN_TYPE_PRE_REGISTRATION_MANAGEMENT {
  list = 'list',
  register = 'register',
  detail = 'detail',
}

export enum DRIVER_STATUS {
  PENDING = 'pending',
  APPROVAL = 'approval',
  FINAL_APPROVAL = 'final_approval',
  RESTRICTED = 'restricted',
}

export enum FACILITY_TAB {
  FACILITY = 'facility',
  ACOUNT = 'account',
}

export enum SYSTEM_CONFIGURATION_TAB {
  // KEY = 'key',
  SETTING = 'setting',
  SMS = 'sms',
}

export const DEFAULT_PAGE = 1;

export const DEFAULT_DURATION = '30';

export const MAX_DURATION = 43200;

export const DRIVER_MANAGEMENT_STATUS = [
  { value: 'pending', label: '认待ち', disabled: false },
  { value: 'approval', label: '认认済', disabled: false },
  { value: 'banned', label: 'アラート(出入禁)', disabled: false },
];

export const DRIVER_DETAIL_STATUS = [
  { value: 'approval', label: '承認済', disabled: false },
  { value: 'banned', label: 'アラート(出入禁止)', disabled: false },
];

export const PRE_REGISTRATION_STATUS = [
  { value: 'pending', label: '承認待ち', disabled: true },
  { value: 'approval', label: '承認', disabled: false },
  { value: 'delete', label: '却下', disabled: false },
  { value: 'restricted', label: '入館制限', disabled: false },
];

export const DRIVER_STATUS_FINAL_APPROVAL_OFF = [
  { value: 'pending', label: '承認待ち', disabled: false },
  { value: 'approval', label: '承認済', disabled: false },
  { value: 'restricted', label: '入館制限', disabled: false },
];

export const DRIVER_STATUS_LIST_ADMIN = [
  { value: 'pending', label: '承認待ち', disabled: false },
  { value: 'approval', label: '承認済', disabled: false },
  { value: 'final_approval', label: '2次承認済', disabled: false },
  { value: 'restricted', label: '入館制限', disabled: false },
];

export const DRIVER_STATUS_LIST_RECEPTIONIST = [
  { value: 'pending', label: '承認待ち', disabled: false },
  { value: 'approval', label: '承認済', disabled: false },
  { value: 'final_approval', label: '2次承認済', disabled: true },
  { value: 'restricted', label: '入館制限', disabled: false },
];

export const DRIVER_STATUS_LIST_DEVELOPER = [
  { value: 'pending', label: '承認待ち', disabled: false },
  { value: 'approval', label: '承認済', disabled: true },
  { value: 'final_approval', label: '2次承認済', disabled: false },
  { value: 'restricted', label: '入館制限', disabled: false },
];

export const TAB_OPTS: Option[] = [
  {
    value: FACILITY_TAB.FACILITY,
    label: 'facility.title',
  },
  {
    value: FACILITY_TAB.ACOUNT,
    label: 'account.title',
  },
];

export const TAB_SETTING: Option[] = [
  {
    value: SYSTEM_CONFIGURATION_TAB.SMS,
    label: 'setting.sms_list.title',
  },
  {
    value: SYSTEM_CONFIGURATION_TAB.SETTING,
    label: 'setting.app_key.setting',
  },
  // {
  //   value: SYSTEM_CONFIGURATION_TAB.KEY,
  //   label: 'setting.app_key.title',
  // },
];

export const ACCOUNT_ROLE = [
  {
    value: 'admin',
    label: 'role.admin',
  },
  {
    value: 'manager',
    label: 'role.manager',
  },
  {
    value: 'receptionist',
    label: 'role.receptionist',
  },
  {
    value: 'develop',
    label: 'role.develop',
  },
];

export const PRE_REGISTRATION_DETAIL_DEFAULT_VALUE = {
  image: '',
  companyName: '',
  fullNameUser: '',
  phoneNumber: '',
  carNumber: '',
  deliveryDestination: '',
  status: '',
  isAlert: false,
  note: '',
  isVerifyPhone: false,
};

export enum BoxStatus {
  UNUSED = 'UNUSED',
  IN_USE = 'IN_USE',
  UNUSABLE = 'UNUSABLE',
}

export enum SMSStatus {
  DONE = 'common.done',
  PENDING = 'common.not_yet',
}

export enum NOTIFICATION_LIST {
  TIME_LIMIT = 'time_limit', // 時間制限: 入館者の滞在が、入館から制限時間を超えた際に発生
  APPROVAL_PENDING = 'approval_pending', // 承認待ち: 承認依頼が送られると発生
  ENTRY_NOTIFICATION = 'entry_notification', // 入館通知: 通知（アラート）ONになっている登録者が入館した際に発生
  ENTRY_LIMIT = 'entry_limit', // 入館制限: アラート改め「入館制限」（出禁）の方が受付端末「入館」ボタンから認証した際に発生
  PRE_APPROVAL = 'pre-approval',
}

export const SETTING_KEYS = {
  APPR_ON: 'APPR_ON',
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
  APPROVAL_ENABLED: 'APPROVAL_ENABLED',
  FINAL_APPROVAL_ON: 'FINAL_APPROVAL_ON',
  LONG_ENTRY_MIN: 'LONG_ENTRY_MIN',
  MOBILE_NUMBER_REQUIRED: 'MOBILE_NUMBER_REQUIRED',
};

export const SETTING_LABELS: Record<string, string> = {
  APPR_ON: '事前承認',
  APPROVAL_REQUIRED: '承認必須',
  APPROVAL_ENABLED: '承認機能',
  FINAL_APPROVAL_ON: 'デベロッパー承認',
  LONG_ENTRY_MIN: '長時間入館の基準(分)',
};

export const SNS_TYPES: Record<string, string> = {
  VERIFY_PHONE: '電話番号認証',
  REQUEST_SENT: '事前承認',
  REQUEST_APPROVED: '事後承認',
  DRIVER_OVERTIME: '指定時間超過時の警告',
};

export const PRE_REGISTER = 'pre_register';
export const TOTAL = 'total';

export const API_PULIC = [
  { apiName: 'get_history', label: 'setting.app_key_data.type_history' },
  {
    apiName: 'get_register',
    label: 'setting.app_key_data.type_list_registered_users',
  },
  {
    apiName: 'get_register_detail',
    label: 'setting.app_key_data.type_registered_users_details',
  },
  {
    apiName: 'search_register',
    label: 'setting.app_key_data.type_search_registered_users',
  },
  { apiName: 'push_noti', label: 'setting.app_key_data.type_event' },
  {
    apiName: 'add_delete_register',
    label: 'setting.app_key_data.type_deleting_registered_users',
  },
];
